module.exports = __webpack_public_path__ + "static/fun-time/games/page004_game1/audio//M_Great.mp3";